import React, { useMemo } from "react";
import { WORD_COLORS } from "@/lib/slides";

export function WordCloud({ words, dark = false }) {
  const items = useMemo(() => (words || []).slice(0, 40), [words]);
  const max = items.reduce((m, w) => Math.max(m, w.count), 1);

  if (!items.length) {
    return (
      <div className={`text-center ${dark ? "text-slate-400" : "text-slate-400"} py-16 text-lg`}>
        Waiting for words to appear…
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 py-6" data-testid="live-word-cloud">
      {items.map((w, i) => {
        const scale = 0.9 + (w.count / max) * 2.6;
        return (
          <span
            key={w.text}
            className="font-display font-extrabold animate-pop-in leading-none tracking-tight"
            style={{
              fontSize: `${scale}rem`,
              color: WORD_COLORS[i % WORD_COLORS.length],
              animationDelay: `${i * 0.03}s`,
            }}
            title={`${w.count}`}
          >
            {w.text}
          </span>
        );
      })}
    </div>
  );
}
